<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.7925 6.96495C20.0774 7.26781 20.0677 7.74894 19.7708 8.03958L9.95604 17.6472C9.47763 18.1155 8.72293 18.1179 8.24174 17.6525L4.23247 13.7753C3.93383 13.4865 3.92126 13.0055 4.20439 12.7009L4.88792 11.9654C5.17105 11.6608 5.64267 11.648 5.94131 11.9368L9.09095 14.9827L18.051 6.21167C18.348 5.92102 18.8196 5.93092 19.1046 6.23378L19.7925 6.96495Z"
        />
    </svg>
</template>
